var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.00047C8 6.25633 7.88839 6.51232 7.66518 6.70731L1.95089 11.707C1.50446 12.0977 0.78125 12.0977 0.334821 11.707C-0.111607 11.3164 -0.111607 10.6837 0.334821 10.2931L5.24286 6.00047L0.335714 1.70694C-0.110715 1.31634 -0.110715 0.683558 0.335714 0.292953C0.782142 -0.0976515 1.50536 -0.0976515 1.95178 0.292953L7.66607 5.29269C7.88929 5.488 8 5.74423 8 6.00047Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddArrow);
export default __webpack_public_path__ + "static/media/add-arrow.b3ae40639be28166b4f6dd423bd44724.svg";
export { ForwardRef as ReactComponent };